import {
  AlertMessage,
  ConfigurableText,
  NavigationPage,
} from '@/app/components'
import PageLoader from '@/authenticated/components/layout/PageLoader'
import Button from '@/components/Button/Button'
import PermissionSection from '@/app/pages/tesla-authentication/verify-permissions/PermissionSection'
import { ButtonContainer } from '@/app/pages/ava/BrandedPage'
import { VehicleLabel } from '@/app/components/TeslaVehiclePermissions/TeslaVehiclePermissions'
import useViewModel from './useViewModel'
import { TeslaEnergyPermissionHeader } from './TeslaEnergyPermissionHeader'

export default function VerifyEnergySystemPermissionsPage() {
  const {
    energySystems,
    isLoading,
    permissionRefreshError,
    missingScopes,
    missingRequiredPermissions,
    handleUpdatePermissions,
    handleContinue,
    handleClose,
  } = useViewModel()

  if (isLoading) {
    return <PageLoader />
  }

  return (
    <NavigationPage
      id="verify-permissions"
      navigationOptions={['back', 'close']}
      onCloseClick={handleClose}
    >
      <NavigationPage.SingleCardContent>
        <div className="flex flex-col gap-8 mb-4">
          <AlertMessage
            variant="error"
            show={permissionRefreshError}
            className="mb-2"
          >
            Your permissions in Optiwatt might be out of sync with what you have
            enabled. We'll automatically sync them later.
          </AlertMessage>
          <div>
            <TeslaEnergyPermissionHeader
              deviceName="Tesla Powerwall"
              missingPermissions={missingScopes.length > 0}
              missingRequiredPermissions={missingRequiredPermissions}
            />
            {energySystems.map((energySystem, index) => (
              <PermissionSection
                authorizationUrl={null}
                key={energySystem.id}
                open={missingScopes.length > 0 && index === 0}
                missingScopes={missingScopes}
                comingSoonPermissions={[]}
                suggestedPermissions={[
                  'Vehicle Information',
                  'Vehicle Charging Management',
                ]}
                requiredPermissions={[
                  'Energy Product Information',
                  'Energy Product Settings',
                ]}
                header={
                  <ConfigurableText variant="body4" className="mb-2">
                    <VehicleLabel
                      name={'Powerwall'}
                      model={energySystem.name ?? 'Powerwall'}
                      iconType={
                        missingScopes.length > 0
                          ? 'missingPermissions'
                          : 'connected'
                      }
                    />
                  </ConfigurableText>
                }
              />
            ))}
          </div>
        </div>
        <ButtonContainer>
          <div className="flex flex-col gap-2">
            {missingScopes.length > 0 && (
              <Button
                variant={missingRequiredPermissions ? 'primary' : 'secondary'}
                id="update-permissions-button"
                onClick={handleUpdatePermissions}
              >
                Update Permissions
              </Button>
            )}
            {!missingRequiredPermissions && (
              <Button
                variant="primary"
                id="continue-button"
                disabled={missingRequiredPermissions}
                onClick={handleContinue}
              >
                Continue
              </Button>
            )}
          </div>
        </ButtonContainer>
      </NavigationPage.SingleCardContent>
    </NavigationPage>
  )
}
